// Müşteri ekranı (ikinci monitör) için anlık durum köprüsü.
// 1) Aynı pencere grubunda: BroadcastChannel + localStorage (anında, sunucusuz).
// 2) Farklı pencere/iframe/cihaz: sunucu köprüsü (/api/display/{key}) — kasa yazar, ekran poll eder.
// Preview iframe'inde storage partitioning yerel köprüyü bozabildiği için sunucu köprüsü esastır.
const CH = "groot-customer-display";
const LS = "groot_cd_state";

let _bc = null;
function chan() {
  if (_bc) return _bc;
  try { _bc = new BroadcastChannel(CH); } catch (e) { _bc = null; }
  return _bc;
}

// ---- Sunucu köprüsü (kasa tarafı) ----
let _remoteKey = null;
let _lastPost = 0;
let _pendingTimer = null;
let _pendingPayload = null;

export function cdSetKey(key) { _remoteKey = key || null; }

function _postRemote(payload) {
  if (!_remoteKey) return;
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("groot_token");
  fetch(`${base}/api/display/${encodeURIComponent(_remoteKey)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  }).catch(() => {});
}

function _syncRemote(payload) {
  if (!_remoteKey) return;
  _pendingPayload = payload;
  const now = Date.now();
  const gap = now - _lastPost;
  if (gap >= 400) {
    _lastPost = now; _postRemote(_pendingPayload); _pendingPayload = null;
  } else if (!_pendingTimer) {
    _pendingTimer = setTimeout(() => {
      _pendingTimer = null; _lastPost = Date.now();
      if (_pendingPayload) { _postRemote(_pendingPayload); _pendingPayload = null; }
    }, 400 - gap);
  }
}

export function cdPost(state) {
  const payload = { ...state, ts: Date.now() };
  try { localStorage.setItem(LS, JSON.stringify(payload)); } catch (e) {}
  const c = chan();
  if (c) { try { c.postMessage(payload); } catch (e) {} }
  _syncRemote(payload);
}

export function cdSubscribe(cb) {
  try { const raw = localStorage.getItem(LS); if (raw) cb(JSON.parse(raw)); } catch (e) {}
  const c = chan();
  const onMsg = (e) => cb(e.data);
  if (c) c.addEventListener("message", onMsg);
  const onStorage = (e) => {
    if (e.key === LS && e.newValue) { try { cb(JSON.parse(e.newValue)); } catch (err) {} }
  };
  window.addEventListener("storage", onStorage);
  return () => {
    if (c) c.removeEventListener("message", onMsg);
    window.removeEventListener("storage", onStorage);
  };
}

// ---- Sunucu köprüsü (ekran tarafı): poll ----
export function cdSubscribeRemote(key, cb) {
  if (!key) return () => {};
  const base = process.env.REACT_APP_BACKEND_URL;
  let stopped = false;
  let lastTs = 0;
  const tick = async () => {
    if (stopped) return;
    try {
      const r = await fetch(`${base}/api/display/${encodeURIComponent(key)}`, { cache: "no-store" });
      if (r.ok) {
        const d = await r.json();
        const st = d && d.state;
        if (st && st.ts && st.ts !== lastTs) { lastTs = st.ts; cb(st); }
      }
    } catch (e) {}
    if (!stopped) setTimeout(tick, 1200);
  };
  tick();
  return () => { stopped = true; };
}
